module.exports = __webpack_public_path__ + "static/media/icon4.5f9dcbb3.svg";